import * as React from "react";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import {
  StyledBlackInformationTypography,
  StyledMainBox,
  StyledRolesDrawer,
} from "../../../components/commonComponents/StyledComponents/styled";
import AssignPermission from "./PermissionList";
// Assign-from-role drawer is hidden for now; keep ./AssignUser.jsx and re-import when we need it again.
// import AssignUser from "./AssignUser";

const RoleDetail = ({ showSection, closeSection, roleInfo }) => {
  const DrawerList = (
    <StyledMainBox sx={{ width: 350, overflowY: "hidden" }} role="presentation">
      <Box height={20} />
      <Typography variant="h6">
        <strong>{roleInfo.role_name}</strong>
      </Typography>
      <Box height={25} />
      <StyledBlackInformationTypography variant="h6" sx={{ marginLeft: 0, fontWeight: "normal" }}>
        Permission Details
      </StyledBlackInformationTypography>
      <Box height={10} />
      <AssignPermission roleInfo={roleInfo} onClose={closeSection} />
    </StyledMainBox>
  );

  return (
    <>
      <StyledRolesDrawer
        variant="permanent"
        open={showSection}
        anchor="right"
        sx={{
          zIndex: "9999",
        }}
      >
        {DrawerList}
      </StyledRolesDrawer>
    </>
  );
};

export default RoleDetail;
